import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSnow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 1920,
	height: 92,
	fill: "none",
	viewBox: "0 0 1920 92",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M-7 273.4h1962V116.1a70.3 70.3 0 0 0-72.5-70.3c-137.2 4.4-439.2 13.1-646.2 13C992 58.6 897.6 29.5 643 22c-99.2-2.9-119 2.6-187.4-4.6C367.1 8.1 226.8 6.7 226.8 6.7L182.6 5s-69-8.5-102-3.6c-34 5.2-68.2 5.2-80.2 28C-7.9 45.4-7 79.5-7 92z"
	})
});
export default SvgSnow;
